import { useRef, useState, FormEvent } from 'react';
import { Container, Stack, TextField } from '@mui/material';

import { ToolbarContainer } from '../../styled/SearchToolbar.styled';
import SuggestionsList from './SuggestionsList';

interface PromptToolbarProps {
  onSubmit(input: string): void;
  suggestions: string[];
  disabled: boolean;
}

const PromptToolbar = ({
  onSubmit,
  suggestions,
  disabled,
}: PromptToolbarProps) => {
  const [input, setInput] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const shouldShowSuggestions = Boolean(suggestions.length) && !disabled;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const prompt = input.trim();

    if (!prompt) return;

    onSubmit(prompt);
    setInput('');
  };

  return (
    <ToolbarContainer>
      <Container maxWidth="sm">
        <Stack spacing={4}>
          {shouldShowSuggestions && (
            <SuggestionsList suggestions={suggestions} onClick={onSubmit} />
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              inputRef={inputRef}
              value={input}
              disabled={disabled}
              onChange={(event) => setInput(event.currentTarget.value)}
              variant="filled"
              size="small"
              label="Введіть ваше повідомлення..."
              fullWidth
            />
          </form>
        </Stack>
      </Container>
    </ToolbarContainer>
  );
};

export default PromptToolbar;
